import React from 'react'
import { graphql } from 'gatsby'

import SEO from '../components/seo'
import { Fullscreen } from '../components/embed'
import { getQueryVar } from '../util'

export default ({ data, location }) => {
    /**
     * The demo is built separately from the prodigy submodule and placed in
     * /static. We need to trick Gatsby into rendering a static HTML site
     * placed in that folder, so we change the extension to .xhtml. Details:
     * https://github.com/gatsbyjs/gatsby/issues/13072#issuecomment-540068716
     *
     * The setting ?view_id= allows direct deep links to individual interfaces.
     * Since the app is rendered in an iframe, we can't easily update it when
     * the user navigates to a different interface.
     */
    const { defaultDemo } = data.site.siteMetadata
    const viewId = getQueryVar(location.search, 'view_id') || defaultDemo
    return (
        <>
            <SEO title="Live Demo" />
            <Fullscreen src={`/live-demo.html?view_id=${viewId}`} />
        </>
    )
}

export const pageQuery = graphql`
    query {
        site {
            siteMetadata {
                defaultDemo
            }
        }
    }
`
